import React, {Component,} from 'react';
import Iframe from 'react-iframe';
import '../styles/Comment.css';


class Comment extends Component {
    constructor(props) {
        super(props);
        this.state = { viewportHeight: 0 };
    }

    componentDidMount() {
        this.updateViewportHeight();
        window.addEventListener('resize', this.updateViewportHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateViewportHeight);
    }

    updateViewportHeight = () => {
        if (typeof window !== 'undefined') {
            this.setState({ viewportHeight: window.innerHeight });
        }
    };

    render() {
        const pxHeight = `${this.state.viewportHeight || (typeof window !== 'undefined' ? window.innerHeight : 800)}px`;

        return (
            <div className="iframe">
                <Iframe
                    url={`${process.env.REACT_APP_DOMAIN}/admin/#/website/${this.props.match.params.website_id}/graphcomment?iframe=sa`} // url back office
                    width="100%"
                    height={pxHeight}
                    id="myId"
                    className="myClassname"
                    display="initial"
                    allowFullScreen/></div>
        );
    }
    
}

export default Comment;